<template>
  <form
    class="form-encontro-inputs"
    @submit.prevent="emit('adicionar')"
  >
    <h4>Informações do Encontro</h4>

    <FormField
      label="Título"
      id="titulo"
      required
      helpText="Informe o título do encontro"
    >
      <input
        type="text"
        id="titulo"
        class="field-input"
        v-model="modelValue.titulo"
        required
      />
    </FormField>

    <FormField
      label="Descrição"
      id="descricao"
      required
      helpText="Descreva as atividades e conteúdo previstos para o encontro"
    >
      <textarea
        id="descricao"
        class="field-input"
        v-model="modelValue.descricao"
        rows="2"
        required
      ></textarea>
    </FormField>

    <section id="datas">
      <FormField
        label="Data início"
        id="horario-inicio"
        required
        helpText="Informe a data e horário de início do encontro"
      >
        <input
          type="datetime-local"
          id="horario-inicio"
          class="field-input"
          v-model="modelValue.inicio_periodo"
          :min="dataMinima"
          required
        />
      </FormField>

      <FormField
        label="Duração"
        required
        helpText="Informe a duração prevista do encontro em horas e minutos"
      >
        <div style="display: flex; gap: 10px; align-items: center">
          <input
            type="number"
            class="field-input"
            min="0"
            placeholder="Horas"
            v-model.number="modelValue.duracaoHoras"
            :disabled="!modelValue.inicio_periodo"
            style="width: 100px"
          />
          <span>h</span>

          <input
            type="number"
            class="field-input"
            min="0"
            max="59"
            placeholder="Minutos"
            v-model.number="modelValue.duracaoMinutos"
            :disabled="!modelValue.inicio_periodo"
            style="width: 120px"
          />
          <span>min</span>
        </div>
      </FormField>
    </section>

    <div id="botoes">
      <button
        id="enviar"
        type="submit"
      >
        Adicionar Encontro
      </button>
    </div>
  </form>
</template>

<script setup>
import FormField from "@/components/common/FormField.vue";

defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  dataMinima: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["update:modelValue", "adicionar"]);
</script>

<style scoped>
.form-encontro-inputs {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 15px;
  padding: 15px;
  box-shadow: var(--shadow-high);
}

#datas {
  display: flex;
  gap: 15px;
  width: 100%;
}

#datas .field-group {
  flex: 1;
  min-width: 0;
}

#botoes {
  margin-top: 15px;
}

@media (max-width: 1024px) {
  #datas {
    flex-direction: column;
    gap: 0;
  }

  #datas .field-group {
    width: 100%;
  }
}
</style>
